/*--------------------------------------------------------------------------\
  websocket.js

  Description
    The "WebSocket" object declaration.

  Copyrights- (C) Copyright 2007-2019 Software Consulting Services, LLC (SCS).
\--------------------------------------------------------------------------*/

/* Create a new WebSocket instance.
    If adding additional identities use the addNewIdentity function
      instead of creating a new instance. There should only be one
      instance of CASWebSocket initially created with the session id. */
function MoaiWebSocket(identity, callback, pageBound=true) {
  const notifyFunc = (isUndefinedOrNull(window.GrowlMessage)) ? notify:
          function(msg) { (new GrowlMessage({"message": msg, "sticky": true})).displayMessage() }
  let messageCallbackList = [];
  let onOpenCallbackList = []

  // Reconnect with exponential backoff: delay = min(MAX, BASE * 2^attempt) + jitter.
  const RECONNECT_BASE_DELAY_MS = 1000   // first retry ~1s
  const RECONNECT_MAX_DELAY_MS  = 30000  // delay ceiling; retries continue indefinitely
  let reconnectAttempts = 0
  let reconnectTimer = null
  let reconnectJitter = null
  let intentionalClose = false
  let hasConnectedBefore = false

  var self = this;
  var portStr = "";
  if ( window.location.port != "" ) {
    portStr = ":" + window.location.port;
  }

  var url = "";
  // Use ws with http and wss with https to avoid browser security complaints.
  if ( window.location.protocol === "https:" ) {
    url = "wss://" + window.location.hostname + portStr + "/ws2";
  } else {
    url = "ws://" + window.location.hostname + portStr + "/ws2";
  }

  function isEquivalent(a, b) {
    // Check if two objects are basically the same. Used for matching broadcast filters
    var aProps = Object.getOwnPropertyNames(a);
    var bProps = Object.getOwnPropertyNames(b);
    if (aProps.length != bProps.length)
        return false;
    for (var i = 0; i < aProps.length; i++) {
        var propName = aProps[i];
        if (a[propName] !== b[propName])
            return false;
    }
    return true;
  }

  let socket // current websocket

  /**
   * Schedules a reconnection attempt using exponential backoff, unless the socket
   * was closed on purpose. Number of attempts is uncapped, and the delay between them
   * is capped at RECONNECT_MAX_DELAY_MS.
   * @returns
   */
  function scheduleReconnect() {
    if (intentionalClose) return
    if (reconnectTimer !== null) return
    // jitter to avoid many clients attempting reconnect at once after wsserver restart
    if (reconnectJitter === null) reconnectJitter = Math.floor(Math.random() * 1000)
    const delay = Math.min(RECONNECT_MAX_DELAY_MS,
                           RECONNECT_BASE_DELAY_MS * Math.pow(2, reconnectAttempts)) + reconnectJitter
    reconnectAttempts++;
    console.log("WS: reconnecting in " + delay + "ms (attempt " + reconnectAttempts + ")");
    reconnectTimer = setTimeout(function() {
      reconnectTimer = null;
      connect(false);
    }, delay);
  }

  /**
   * Attempts to create a websocket connection and add handlers
   */
  function connect(isFirst) {
    try {
      socket = new WebSocket(url);
    }
    catch (err) {
      console.log( "Failed to make web socket connection (" + err.message + ")!" );
      if (isFirst) throw err;
      scheduleReconnect();
      return;
    }

    socket.onclose = function(ev) {
      console.log('WS: CAS Websocket Closed', ev)
      scheduleReconnect();
    }

    socket.onopen = function(e) {
      console.log("WS: CASWebsocket Open");
      reconnectAttempts = 0;
      if (!hasConnectedBefore) {
        hasConnectedBefore = true;
        self.addNewCallback(identity, callback);
      }
      else {
        // Resend every callback on reconnection
        for (const callbackObj of messageCallbackList) {
          if (callbackObj.method === "send") continue; // don't replay in-flight sends
          socket.send(JSON.stringify({ "jsonrpc": "2.0", method: "register", params: callbackObj.identity, "id": 0 }));
        }
      }
      for (const callback of onOpenCallbackList) { // run callbacks that were added to queue before websocket was opened
        callback()
      }
      onOpenCallbackList = []
    };

    socket.onerror = function(e) {
      console.log("socket onerror", e);
      console.error(e);
    };

    socket.onmessage = function(e) {
      const data = JSON.parse(e.data);
      let resp, filter, registerFunc
      let error = false
      if (data.result !== undefined) {
        resp = data.result
        filter = data.id
        registerFunc = false
      }
      else if (data.params) {
        resp = data.params,
        filter = resp.filter;
        registerFunc = true
      }
      else if (data.error) {
        resp = data
        error = true
        filter = data.id
      }
      if (typeof filter !== "undefined") {
        // Find the callback with the matching identity registered for this page
        const callbackIndex = messageCallbackList.findIndex(callbackObj => isEquivalent(filter, callbackObj.identity))
        const callbackObj = messageCallbackList[callbackIndex]
        function callbackFunc() {
          if (error) {
            if (callbackObj.errorCallback) {
              callbackObj.errorCallback(resp)
            }
            messageCallbackList.splice(callbackIndex, 1);
          }
          else {
            // If the callback returned true, remove it from the list
            if (callbackObj.callback(resp)) {
              messageCallbackList.splice(callbackIndex, 1);
            }
          }
        }
        // Check if we are on the correct page to trigger the event
        if (isUndefinedOrNull(callbackObj.hash) || callbackObj.hash == CurrentHash) {
          callbackFunc();
        }
        else if ((callbackObj.method !== "send") ) {
          // Don't trigger the callback;
          //    instead offer to navigate back to the page and then trigger it
          var $div = $("<div/>");
              $button = $('<button class="btn btn-info">Go to Page</button>');
          $div.append("<h5>" + callbackObj.title + "</h5>")
              .append("<h5><small>New Event Message:</small></h5>")
              .append("<pre>" + resp.message + "</pre>")
              .append("<br/>").append($button);
          $button.click(function(e) {
            HashNavigate(callbackObj.hash);
            callbackFunc();
            $(e.currentTarget).parents("#alert-box").find("a.close").click();
          });
          notify($div, "info", true, 0, false);
        }
      } else {
        notifyFunc(resp.message);
      }
    };
  }

  connect(true);

  /* Add a new callback to the page's current websocket.
     Do a check in with the ws server with the new indentity and
       then if a message with that identity comes in: call the
       callback using the message. */
  this.addNewCallback = function(params, callback, errorCallback, method, identity) {
    const bsPage = pageBound && !isUndefinedOrNull(window["CurrentHash"])
    messageCallbackList.push({
      identity: identity ?? params,
      callback,
      errorCallback,
      hash: bsPage ? CurrentHash : undefined,
      title: bsPage ? document.title.slice(5) : undefined,
      method
    });

    const jsonrpc = { "jsonrpc": "2.0", method: method ?? "register", params, "id": 0 };
    if ( this.isOpen() ) {
      socket.send(JSON.stringify(jsonrpc));
    }
  };

  let listenerIndex = 0
  /**
   * Sends a message to MOAI via the websocket. Callback will execute on successful message return from MOAI (errors returned by an application
   * should be handled here) and errorCallback will execute if there is an error communicating with MOAI via the websocket
   * @param { string } destination
   * @param { string } action
   * @param { Record<string, any> } args
   * @param { (resp) => boolean } callback
   * @param { (resp) => void } errorCallback
   */
  this.sendMOAIMessage = function (destination, action, args, callback, errorCallback) {
    const params = {
      message:
        {
          jsonrpc: "2.0",
          method: "recv_localRequest",
          id: listenerIndex,
          params: {
            usrid:"DummyUser",
            origin:"DummyOrigin",
            action,
            destination,
            args
          }
        }
    }
    listenerIndex ++
    if (this.isOpen()) { // if socket is open, send request immediately
      this.addNewCallback(params, callback, errorCallback, "send", listenerIndex)
    }
    else { // otherwise add it to queue to be sent when socket is opened
      onOpenCallbackList.push(() => this.addNewCallback(params, callback, errorCallback, "send", listenerIndex))
    }
  }

  /* This is used by the bootstrap pages to clear out websocket events
        when performing a hash navigation. It will remove socket callbacks
        with a hash that isn't accounted for in the page history. */
  this.clearCallbacks = function() {
    var hashHistory = __HISTORY_PAGE_CONTENT.map(function(e){return e.hash});
    hashHistory.push(CurrentHash);
    messageCallbackList = messageCallbackList.filter(function(e) {
      return isUndefinedOrNull(e.hash) ||
             hashHistory.indexOf(e.hash) != -1;
    });
  };

  this.close = function() {
    intentionalClose = true;
    if (reconnectTimer !== null) {
      clearTimeout(reconnectTimer);
      reconnectTimer = null;
    }
    socket.close();
  }

  this.isOpen = function() {
    return socket.readyState === socket.OPEN;
  }
}

// END OF FILE: websocket.js
